import { searchMarketplaceProducts } from "@/api/services/marketplace";
import {
  buildProductSearchRequest,
  ensureFilterMappingIncludesUrlTerms,
  mapProductSearchResponse,
  marketplaceKeys,
  parseCheckboxFiltersFromSearchParams,
  parseMarketplaceSearchFromParams,
  type MarketplaceListingQueryResult,
} from "@/lib/marketplace";
import { useQuery } from "@tanstack/react-query";

export const useMarketplaceListing = (
  searchKey: string,
  filterMapping: Record<string, Record<number, string>>,
  page = 1
) => {
  const searchParams = new URLSearchParams(searchKey);
  const resolvedFilterMapping = ensureFilterMappingIncludesUrlTerms(
    filterMapping,
    searchParams
  );
  const checkboxFilters = parseCheckboxFiltersFromSearchParams(
    searchParams,
    resolvedFilterMapping
  );
  const searchText = parseMarketplaceSearchFromParams(searchParams);

  return useQuery({
    queryKey: marketplaceKeys.listing(searchKey, page),
    queryFn: () =>
      searchMarketplaceProducts(
        buildProductSearchRequest(
          checkboxFilters,
          resolvedFilterMapping,
          searchText
        ),
        page
      ),
    select: (response): MarketplaceListingQueryResult =>
      mapProductSearchResponse(response, searchText),
    staleTime: 60_000,
  });
};
